import React, { Component } from 'react';
import base from '../base';
import {
  Grid,
  Row,
  Col,
} from 'react-bootstrap';

import Profile from './Profile';
import WorkoutHistory from './WorkoutHistory';

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.createWorkout = this.createWorkout.bind(this);
    this.workoutNode = `workouts/${this.props.user.uid}`;
    this.state = {
      workouts: {}
    }
  }

  componentWillMount() {
    this.ref = base.syncState(this.workoutNode, {
      context: this,
      state: 'workouts'
    });
  }

  componentWillUnmount() {
    base.removeBinding(this.ref);
  }

  createWorkout() {
    const workoutsRef = base.database().ref(this.workoutNode);
    const workoutId = workoutsRef.push();
    const workout = {
      key: workoutId.key,
      total: 0,
      timeStamp: Date.now(),
      sets:{}
    };
    workoutId.set(workout);
  }

  render() {
    const { workouts } = this.state;
    const total = Object.keys(workouts)
                        .reduce((total, key) => total + workouts[key].total, 0);
    return(
      <Grid>
        <Row>
          <Col md={9} mdPush={3}>
            <Profile displayName={this.props.user.displayName} totalLifted={total}/>
          </Col>
          <Col md={3} mdPull={9}>
            <WorkoutHistory workouts={workouts} createWorkout={this.createWorkout} />
          </Col>
        </Row>
      </Grid>
    );
  }
}

Dashboard.propTypes = {
  user: React.PropTypes.object.isRequired
}

export default Dashboard;


// WEBPACK FOOTER //
// ./src/components/Dashboard.jsx